import { Avatar, Stack, Typography } from "@mui/material";
import TestimonialsWrapper from "src/components/ui/testimonials-wrapper";
import AVCTheme from "src/config/mui-theme/AVCThemeConfig";

const TestimonialCard = ({ avatar, firstname, job, description, date }) => (
  <TestimonialsWrapper>
    <Stack
      spacing={2}
      p={2}
      bgcolor="grey.g7"
      sx={{ borderRadius: AVCTheme.borderRadius.md }}
      textAlign="justify"
      justifyContent="center"
    >
      <Stack direction="row" justifyContent="start" alignItems="center" spacing={1}>
        {avatar ? (
          <Avatar
            alt={firstname}
            src={avatar}
            sx={{
              width: 48,
              height: 48,
            }}
          />
        ) : (
          <Avatar
            sx={{
              width: 48,
              height: 48,
            }}
          >
            <Typography variant="body1">{firstname.charAt(0)}</Typography>
          </Avatar>
        )}

        <Stack>
          <Typography variant="body2" color="text.primary">
            {firstname}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {job}
          </Typography>
        </Stack>
      </Stack>

      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
      <Typography variant="caption" color="text.tertiary">
        {date}
      </Typography>
    </Stack>
  </TestimonialsWrapper>
);

export default TestimonialCard;
